<template>
  <div style="margin-right: 30px">
    <!--  当前的审批节点  -->
    <a-button disabled>{{ currentKey }}</a-button>
    <!--  管理员审批  -->
    <!--    <a-button :disabled="canOperate"-->
    <!--              v-if="user.id===13"-->
    <!--              type="primary"-->
    <!--              @click="adminSubmitPanel">管理员提交-->
    <!--    </a-button>-->

    <!--草稿节点/新建节点 保存并审批-->
    <a-button :disabled="canOperate"
              v-if="currentKey==='草稿'&&submit"
              type="primary"
              @click="saveAndSubmit">保存并审批
    </a-button>
    <!--普通节点无保存只提交审批-->
    <a-button :disabled="canOperate"
              v-if="confirm&&!needSave"
              type="primary"
              @click="showPanelVisible(false)">提交审批
    </a-button>
    <!--保存并提交审批-->
    <a-button :disabled="canOperate"
              v-if="confirm&&needSave"
              type="primary"
              @click="showPanelVisible(false)">保存并审批
    </a-button>

    <!--驳回到草稿-->
    <a-button :disabled="canOperate"
              v-if="currentKey!=='草稿'&&currentKey!=='完成'&&info.draft"
              type="primary"
              @click="showPanelVisible(true)">驳回到草稿
    </a-button>

    <!--查看审批记录-->
    <a-button :disabled="canOperate"
              v-if="info.history"
              type="primary"
              @click="showHisPanel">查看审批记录
    </a-button>

    <a-modal
        title="审批意见"
        centered
        :visible="showAuditAndSave"
        @ok="triggerPanelOrAudit"
        @cancel="showAuditAndSave = false"
        :width="600"
    >
      <a-spin :spinning="canOperate">
        <a-textarea placeholder="审批意见" v-model="enableSaveAndAudit" :maxLength="50"/>
      </a-spin>
    </a-modal>


    <a-modal
        title="查看审批记录"
        centered
        :visible="showHistory"
        :footer="null"
        @cancel="showHistory = false"
        :width="800"
    >
      <div style="width: 700px;height: 200px;background: #fff;margin: 0 auto">
        <img style="width: 100%;height: 100%;object-fit: contain" :src="recordImg" alt="">
      </div>

      <vxe-grid
          ref="xGrid"
          column-key
          class="column-sortable-grid"
          v-bind="gridOptions"
          :data="list"
          :auto-resize="true"
      >
      </vxe-grid>
    </a-modal>

  </div>
</template>

<script>
import {dataApi} from '@/services/workflow/workflow';
import api from '@/services/api'
import {mapGetters} from 'vuex'

export default {
  /**
   * 将当前用户加载到页面中
   */
  props: {
    /**
     * 是否需要保存并提交审批
     */
    needSave: {
      type: Boolean,
      default: false
    },
    needNew:{
      type:Boolean,
      default:false
    }
  },
  watch: {
    /**
     * 监听状态判断
     */
    needSave: {
      immediate: true,
      handler(val) {
        if (val) {
          console.log(val)
        }
      }
    }
  },
  computed: {
    ...mapGetters('account', ['user'])
  },
  data() {
    return {
      canOperate: false,
      list: [],
      gridOptions: {
        border: true,
        resizable: true,
        showHeaderOverflow: true,
        showOverflow: true,
        highlightHoverRow: true,
        keepSource: true,
        // id: this.id,
        height: 300,
        columns: [{
          field: "nodeName",
          title: "节点名称",
          width: 160,
        }, {
          field: "username",
          title: "审批人",
          width: 120,
        }, {
          field: "operateType",
          title: "操作类型",
          width: 120,
        }, {
          field: "operateDate",
          title: "审批时间",
          width: 160,
        }, {
          field: "decision",
          title: "审批意见",
          width: 300,
        }],
      },
      submit: false,
      submitName: '',
      param: [],
      info: {
        preName: '',
        forwardName: '',
        draftName: '',
        cancelName: '',
        revokeName: '',
        backlastName: '',
      },
      showAuditAndSave: false,
      enableSaveAndAudit: '',
      currentKey: '',
      taskId: '',
      instanceId: '',
      confirm: false,
      operate: false,
      subStatus: 0,
      keyId: '',
      menuId: '',
      showHistory: false,
      recordImg: '',
      operateType: false
    }
  },
  methods: {
    async loadWord(rowId, businessNo) {
      if(this.needNew){
        rowId = 0
      }
      this.menuId = businessNo;
      if (rowId) {
        this.keyId = rowId;
        let data = await dataApi.getInfo(rowId, businessNo).catch(() => {
          this.info = {};
          this.confirm = false;
          this.submit = false;
        });

        this.info = data.data;

        this.currentKey = data.data.currentKey;
        this.taskId = data.data.taskId;
        this.instanceId = data.data.instanceId;

        this.confirm = !!data.data.confirm;
        this.submit = !!data.data.submit;


        if (this.submit) {
          this.submitName = '提交审批';
          this.operate = true;
          this.subStatus = 5;
        }

        this.info.reject = !!data.data.reject;
        if (this.info.reject) {
          this.operate = true;
          this.subStatus = 2;
        }

        this.info.confirm = !!this.info.confirm;
        if (this.info.confirm) {
          this.operate = true;
          this.subStatus = 1;
        }

        this.info.draft = !!this.info.draft;
        if (this.info.draft) {
          this.subStatus = 4;
        }

        this.info.cancel = !!this.info.cancel;
        if (this.info.cancel) {
          this.subStatus = 3;
        }

        this.info.revoke = !!this.info.revoke;

        this.info.backlast = !!this.info.backlast;

        this.info.history = !!this.info.history;
      } else {
        this.currentKey = '草稿';
        this.submit = true;
        this.submitName = '保存并提交审批'
      }
    },
    /**
     * 查看审批记录
     */
    async showHisPanel() {
      let res = await dataApi.getRecord(this.instanceId);
      this.list = res.data.list;
      this.recordImg = `${api.TEMP.BASE_URL}/act/explorer/read-resource?processInstanceId=${this.instanceId}&token=${this.user.token}`
      this.showHistory = true;
    },

    /**
     * 驳回审批
     */
    async rejectAudit() {
      if (!this.enableSaveAndAudit || !(this.enableSaveAndAudit && this.enableSaveAndAudit.trim())) {
        return this.$message.error('请输入审批意见');
      }
      if (this.enableSaveAndAudit.length > 50) {
        return this.$message.error('审批意见应少于50个字符');
      }
      this.canOperate = true;
      this.showAuditAndSave = false;
      let obj = {
        keys: 'approve',
        values: true,
        types: 'B',
        decision: this.enableSaveAndAudit,
        oneStepOnly: 0
      }
      await dataApi.draft(this.taskId, obj).catch(() => {
        this.canOperate = false;
        this.$emit('refresh', '');
      });
      this.canOperate = false;
      this.$emit('refresh', '驳回审批成功');
    },
    /**
     * 提交审批
     */
    async submitAudit() {
      if (!this.enableSaveAndAudit || !(this.enableSaveAndAudit && this.enableSaveAndAudit.trim())) {
        return this.$message.error('请输入审批意见');
      }
      if (this.enableSaveAndAudit.length > 50) {
        return this.$message.error('审批意见应少于50个字符');
      }
      this.canOperate = true;
      this.showAuditAndSave = false;
      let obj = {
        keys: 'approve',
        values: true,
        types: 'B',
        decision: this.enableSaveAndAudit || ''
      }

      if (this.needSave) {//是否是保存并提交审批
        this.$emit('save', async (val, status) => {
          if (!status) {
            this.canOperate = false;
            return
          }
          await dataApi.complete(this.taskId, obj).then(() => {
            this.canOperate = false;
            this.$emit('refresh', '提交审批成功');
          }).catch(() => {
            this.canOperate = false;
            this.$emit('refresh', '', this.keyId);
          });
        })
      } else {//直接提交审批
        await dataApi.complete(this.taskId, obj).then(() => {
          this.canOperate = false;
          this.$emit('refresh', '提交审批成功');
        }).catch(() => {
          this.canOperate = false;
          this.$emit('refresh', '', this.keyId);
        });
      }
    },
    /**
     * 审批或驳回
     */
    triggerPanelOrAudit() {
      // console.log(this.operateType)
      if (this.operateType) {//驳回
        this.rejectAudit();
      } else {
        this.submitAudit();
      }
    },
    /**
     * 提交审批显示审批意见
     */
    showPanelVisible(isReject) {
      this.showAuditAndSave = true;
      this.operateType = !!isReject;
    },
    /**
     * 保存并审批
     * 不需要提交审批意见 直接审批且触发保存
     */
    saveAndSubmit() {
      this.canOperate = true;
      this.$emit('save', async (val, status) => {
        if (!status) {
          this.canOperate = false;
          return
        }
        this.keyId = val;
        let obj = {
          keys: 'approve',
          values: true,
          types: 'B',
          decision: ''
        }
        await dataApi.submit(this.menuId, this.keyId, '', this.taskId, false, obj).then(() => {
          this.canOperate = false;
          this.$emit('refresh', '提交审批成功');
        }).catch(() => {
          this.canOperate = false;
          this.$emit('refresh', '', this.keyId);
        });
      })
    }
  },

};
</script>

<style scoped type="less">
button {
  margin-left: 5px;
}

.ant-btn-danger {
  background: rgba(204, 204, 204, 0.2);
  border: 1px solid #ccc;
  color: #ccc;
}

.ant-btn-primary {
  background: rgba(3, 122, 129, 0.2);
  border: 1px solid #037a81;
  color: #037a81;
}
</style>

